// Must stay in sync with backend PERMISSION_MODULES.
export const PERMISSION_MODULES = [
  { key: "orders", label: "Orders & Shipments", desc: "Order and shipment history" },
  { key: "delivery", label: "Delivery Tracking", desc: "Live tracking of packages" },
  { key: "billing", label: "Billing & Pricing", desc: "Costs, rates and pricing", sensitive: true },
  { key: "invoices", label: "Invoices", desc: "Invoices and statements", sensitive: true },
  { key: "claims", label: "Claims", desc: "Damage / loss claims" },
  { key: "returns", label: "Returns", desc: "Returned items and dispositions" },
  { key: "inventory", label: "Inventory & POs", desc: "Stock, bins and inbound POs" },
  { key: "reports", label: "Reports", desc: "Analytics and exports" },
  { key: "documents", label: "Documents", desc: "Shared files and contracts" },
];

export function emptyPermissions() {
  const out = {};
  PERMISSION_MODULES.forEach((m) => { out[m.key] = { view: false, manage: false }; });
  return out;
}

export function normalizePermissions(perms) {
  const base = emptyPermissions();
  if (perms && typeof perms === "object") {
    PERMISSION_MODULES.forEach((m) => {
      const p = perms[m.key];
      if (p) base[m.key] = { view: !!(p.view || p.manage), manage: !!p.manage };
    });
  }
  return base;
}
